import SiteWideBanner from './sitewide-banner/sitewide-banner';

declare global {
    interface Window {
        saitAlerts: any;
     }
}

const globalAlertsInit =  () => {
    // global js functions
    window.saitAlerts = new SiteWideBanner();
}

// enable alerts
globalAlertsInit();